import { Firebase } from '06_shared/lib/firebase';

export const withFirebase = () => Firebase.initializeFirebase();
